"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Code, Cpu, Globe } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const BUSINESS_NAME = "geroi.eu";
const SUBTEXT = "Non costruiamo siti. Forgiamo infrastrutture blindate, sblocchiamo corridoi logistici riservati e scaliamo fatturati (Est/Ovest).";
export default function IlFuturoDellaTuaPmi() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="24053" id="ingegneria-della-dominazione" className="dark bg-[#0A0A0A] text-white relative overflow-hidden min-h-screen flex items-center">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-[#DC143C]/10 via-[#0A0A0A] to-[#0A0A0A] pointer-events-none" />

      <div className="container mx-auto px-4 pt-40 pb-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col gap-8 max-w-3xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-none bg-[#DC143C]/10 border border-[#DC143C]/30 w-fit">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-none bg-[#DC143C] opacity-75"></span>
                <span className="relative inline-flex rounded-none h-2 w-2 bg-[#DC143C]"></span>
              </span>
              <span className="text-xs font-medium text-[#F5E6BE] tracking-widest uppercase font-mono">
                Titanium Corporate
              </span>
            </div>

            {}
            <h1 className="text-5xl md:text-7xl lg:text-[120px] font-serif font-bold leading-[1] tracking-tighter">
              <span className="bg-gradient-to-r from-white via-white to-[#F5E6BE] bg-clip-text text-transparent">
                Ingegneria Strategica
              </span>
              <br />
              <span className="text-white">per la Dominazione.</span>
            </h1>

            {}
            <p className="text-lg md:text-2xl font-sans text-white/90 leading-relaxed max-w-xl border-l-2 border-[#F5E6BE]/30 pl-6">
              Non costruiamo siti. Forgiamo <span className="text-[#F5E6BE] font-light">infrastrutture blindate</span>, sblocchiamo <span className="text-[#F5E6BE] font-light">corridoi logistici riservati</span> e scaliamo fatturati (Est/Ovest).
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-[#DC143C] to-[#0A0A0A] rounded-none blur opacity-25 group-hover:opacity-75 transition duration-1000 group-hover:duration-200"></div>
                <Button asChild size="lg" className="relative h-14 px-8 text-lg font-serif bg-[#DC143C] hover:bg-[#DC143C]/90 text-white rounded-none border-0 shadow-[0_0_20px_rgba(220,20,60,0.3)] hover:shadow-[0_0_40px_rgba(220,20,60,0.5)] transition-all duration-300">
                  <Link to="#">
                    Richiedi Audit di Salvataggio
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
              </div>
              
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg font-serif rounded-none border-white/20 hover:bg-white/5 hover:text-[#F5E6BE] transition-colors">
                <Link to="#">
                  Divisione Vostoka
                </Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-6 mt-8 text-white/40">
              <div className="flex items-center gap-2">
                <Code className="h-5 w-5" />
                <span className="text-sm font-mono uppercase tracking-widest">Cyber Security</span>
              </div>
              <div className="flex items-center gap-2">
                <Cpu className="h-5 w-5" />
                <span className="text-sm font-mono uppercase tracking-widest">Global Entry</span>
              </div>
              <div className="flex items-center gap-2">
                <Globe className="h-5 w-5" />
                <span className="text-sm font-mono uppercase tracking-widest">B2B Logistics</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative h-[500px] lg:h-[700px] w-full flex items-center justify-center perspective-1000">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#DC143C]/5 blur-[120px] rounded-none pointer-events-none" />
            
            {}
            <div className="w-full h-full relative z-10 rounded-none overflow-hidden border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl">
              {mounted && <div className="w-full h-full bg-gradient-to-br from-[#DC143C]/20 via-[#0A0A0A] to-[#0A0A0A] flex items-center justify-center relative">
                  <style>{`
                    @keyframes float-box {
                      0%, 100% { transform: translateY(0px) rotateX(0deg) rotateY(0deg); }
                      50% { transform: translateY(-20px) rotateX(10deg) rotateY(10deg); }
                    }
                    @keyframes pulse-glow {
                      0%, 100% { opacity: 0.5; }
                      50% { opacity: 1; }
                    }
                    .floating-box {
                      animation: float-box 6s ease-in-out infinite;
                    }
                    .pulse-element {
                      animation: pulse-glow 3s ease-in-out infinite;
                    }
                  `}</style>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="floating-box w-32 h-32 bg-[#DC143C]/30 rounded-none border border-[#DC143C]/50 backdrop-blur-md" />
                    <div className="absolute floating-box w-24 h-24 bg-[#F5E6BE]/20 rounded-none border border-[#F5E6BE]/30 backdrop-blur-md" style={{
                  animationDelay: '1s'
                }} />
                    <div className="absolute floating-box w-16 h-16 bg-white/10 rounded-none border border-white/30 backdrop-blur-md" style={{
                  animationDelay: '2s'
                }} />
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent pointer-events-none" />
                </div>}
              
              {}
              <div className="absolute top-4 left-4 flex gap-2">
                <div className="w-3 h-3 rounded-none bg-[#DC143C]/50" />
                <div className="w-3 h-3 rounded-none bg-[#F5E6BE]/50" />
                <div className="w-3 h-3 rounded-none bg-white/50" />
              </div>
              
              <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end pointer-events-none">
                <div className="font-mono text-[10px] text-[#F5E6BE]/70 bg-black/80 px-3 py-2 rounded-none backdrop-blur-md border border-[#F5E6BE]/20 uppercase tracking-widest">
                  STATUS: SECURE_VAULT
                  <br />
                  INTEL: ACQUIRING_TARGET
                </div>
                <div className="font-mono text-[10px] text-white/40 text-right tracking-widest">
                  COORD: {`{ 41.9028° N, 12.4964° E }`}
                  <br />
                  HQ: GEROI_GLOBAL
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}